import { Link } from 'react-router-dom';
import { ArrowRight, BadgeCheck, Clock, MapPin, Star } from 'lucide-react';
import { PriceOnRequest } from './PriceOnRequest';
import { useLang } from '../i18n';
import { FavoriteButton } from './FavoriteButton';

export const MarketplaceCard = ({ to, image, eyebrow, title, location, duration, partner, cta, testid, imageBadge, priceLabel, priceTestid, experience }) => {
  const { t } = useLang();
  return (
  <article data-testid={testid} className="group eco-card relative flex h-full flex-col">
    {experience && <FavoriteButton experience={experience} className="absolute top-3 right-3 z-10" />}
    <Link to={to} className="flex h-full flex-col rounded-2xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-eco-gold">
    <div className="relative h-56 shrink-0 overflow-hidden rounded-t-2xl">
      {image ? (
        <img src={image} alt={title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]" />
      ) : (
        <div className="grid h-full place-items-center bg-eco-green text-5xl font-bold text-eco-gold">{title.charAt(0)}</div>
      )}
      {imageBadge && <span className="absolute top-4 left-4 rounded-full bg-white/95 px-3 py-1 text-[12px] font-medium text-eco-ink shadow-sm">{imageBadge}</span>}
    </div>
    <div className="flex flex-1 flex-col p-5">
      <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-eco-gold">{eyebrow}</p>
      <h3 className="eco-card-title mt-2">{title}</h3>
      {experience?.rating_summary ? <p className="mt-2 flex items-center gap-1 text-sm font-semibold text-eco-ink/65"><Star size={14} fill="currentColor" className="text-eco-gold" /> {experience.rating_summary.average} ({experience.rating_summary.count})</p> : null}
      <p className="eco-meta mt-2 flex flex-wrap items-center gap-x-3 gap-y-1">
        {duration && <span className="inline-flex items-center gap-1"><Clock size={13} /> {duration}</span>}
        {location && <span className="inline-flex items-center gap-1"><MapPin size={13} /> {location}</span>}
      </p>
      <p className="eco-meta mt-2 flex items-center gap-1.5"><BadgeCheck size={14} className="text-eco-green" /> {partner}</p>
      <div className="mt-4 border-t border-eco-ink/10 pt-4">
        {priceLabel ? (
          <div data-testid={priceTestid || `${testid}-price`} className="eco-price-approved p-3">
            <p className="eco-price-label">{t('price.label')}</p>
            <p className="eco-price-value">{priceLabel}</p>
          </div>
        ) : (
          <PriceOnRequest compact testid={priceTestid || `${testid}-price`} />
        )}
      </div>
      <span className="eco-btn-text mt-4 self-start">{cta} <ArrowRight size={14} className="transition-transform duration-200 group-hover:translate-x-1" /></span>
    </div>
    </Link>
  </article>
  );
};
